var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"translateBtn",on:{"click":_vm.translateFun}},[_vm._v("translate")]),(_vm.show)?_c('span',[_c('Translator')],1):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }